import { render, staticRenderFns } from "./accountStatistics.vue?vue&type=template&id=ddf59674&scoped=true&"
import script from "./accountStatistics.vue?vue&type=script&lang=js&"
export * from "./accountStatistics.vue?vue&type=script&lang=js&"
import style0 from "./accountStatistics.vue?vue&type=style&index=0&id=ddf59674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf59674",
  null
  
)

export default component.exports